import { useMutation } from '@tanstack/react-query';
import { osmPost } from '@/api/osmClient';
import type { RouteRequest, RouteResponse } from '@/types/osm';

export function useOsmRoute() {
  return useMutation<RouteResponse, Error, RouteRequest>({
    mutationFn: (req) => osmPost<RouteResponse, RouteRequest>('/route', req),
  });
}

export function useOsmOptimized() {
  return useMutation<RouteResponse, Error, RouteRequest>({
    mutationFn: (req) => osmPost<RouteResponse, RouteRequest>('/optimized', req),
  });
}
